module.exports = "/images/social-twitter-light.png?b4d84bbeeeea7168decfb47576459860";